import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AbstractStateInterface } from '../../interface/abstract';
import { ApiService } from '../../utils/apiService';
import { UserInterface } from '../../interface/user';

type DataState = AbstractStateInterface<UserInterface>;
const initialState: DataState = {
  data: [],
  detail: null,
  loading: false,
};

export const getListUsers = createAsyncThunk('/admin-api/users', async (_, thunkAPI) => {
  try {
    const response = await ApiService(`/admin-api/users`, 'GET', null);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserSlice: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListUsers.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload.data)) {
          const fillEmail = action.payload.data.filter((item) => item.email);
          state.data = fillEmail as UserInterface[];
        } else {
          state.data = [];
        }
      })
      .addCase(getListUsers.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { resetUserSlice } = userSlice.actions;
export default userSlice.reducer;
